import { FC } from 'react'

import {
  Text,
  GreyGrey80,
  Primary13Regular,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'

export const ModalRestoreVersion: FC<{
  onClose: () => void
  onRestore: () => void
}> = ({ onClose, onRestore }) => {
  const { displayNotification } = useNotifications()

  return (
    <SimpleModal
      variant="dialog"
      isOpen
      onClose={onClose}
      width="436px"
      title="Restore version"
      data-testid="automations.editor.restoreModal"
      onSubmit={() => {
        try {
          onRestore()
          displayNotification('Version restored', { type: 'success' })
          return true
        } catch {
          displayNotification('Failed to restore version', { type: 'error' })
          return false
        }
      }}
      submitButtonText="Restore"
      submittingButtonText="Restoring..."
      disableSubmitOnEnter
    >
      <Text {...Primary13Regular} color={GreyGrey80}>
        Are you sure you want to restore this version? Any unsaved changes will
        be lost.
      </Text>
    </SimpleModal>
  )
}
